import React from "react";
import ContentLoader from "react-content-loader";

export default function ListLoader({ title }) {
  return (
    <div style={{ pointerEvents: "none" }}> {/* ✅ disables hover */}
      <ContentLoader
        speed={2}
        width="100%"
        height={650}
        backgroundColor="rgb(255, 242, 231)"
        foregroundColor="#ecebeb"
        style={{ pointerEvents: "none" }} // ✅ extra safety
      >
        {/* Optional title */}
        <text
          x="50%"
          y="50"
          textAnchor="middle"
          fontSize="30"
          fill="#999"
        >
          {title}
        </text>

        {/* Skeleton items */}
        <rect x="0" y="80" rx="25" ry="25" width="100%" height="140" />
        <rect x="0" y="240" rx="25" ry="25" width="100%" height="140" />
        <rect x="0" y="400" rx="25" ry="25" width="100%" height="140" />
        <rect x="0" y="560" rx="25" ry="25" width="100%" height="140" />
      </ContentLoader>
    </div>
  );
}